import * as React from 'react';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import styled from '@emotion/styled';

export enum BASE {
  LEFT = 'left',
  RIGHT = 'right',
}
interface ConnectionLineProps {
  base: BASE;
  [prop: string]: any;
}

const ConnectionLine: React.FC<ConnectionLineProps> = ({ base, ...rest }) => {
  const { colors } = flameTheme;
  const color = colors['gray-300'];
  const thickness = 2;

  const StyledFlex = styled(Flex)<{ base: BASE }>`
    ${props => `border-${props.base}: ${thickness}px solid ${color}`};
  `;

  return (
    <StyledFlex flexDirection="column" width="100%" height="10px" base={base} {...rest}>
      <Box
        width="100%"
        height="50%"
        style={{ borderBottom: `${thickness / 2}px solid ${color}` }}
      />
      <Box width="100%" height="50%" style={{ borderTop: `${thickness / 2}px solid ${color}` }} />
    </StyledFlex>
  );
};

export { ConnectionLine };
